export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	   "funcion": 'Video Semanal.',
		"url" : 'https://www.facebook.com/share/v/1G9DXVoVPq/',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/rtregidora.jpg',
	   "funcion": 'Rutas de la Transformación.',
		"url" : 'https://www.facebook.com/share/p/1c8p9zaQwM/',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/dulcecampos.jpg',
	   "funcion": 'Podcast del Pueblo.',
		"url" : 'https://www.facebook.com/share/v/18Cox3MyM2/',
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]